export const SUPPORTED_LANGUAGES = [
  'en',
  'es',
  'pt-BR',
  'de',
  'fr',
  'it',
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const CANONICAL_TOKENS = [
  'title',
  'date',
  'time',
  'from',
  'location',
  'eventlocation',
  'videolink',
] as const;

export type CanonicalToken = (typeof CANONICAL_TOKENS)[number];

export interface CalendarStatusLabels {
  pending: string;
  confirmed: string;
  cancelled: string;
  lateCancelled: string;
}

export interface LocalizedDefaultStrings {
  reminderMessage: string;
  /**
   * The reminder wording the onboarding test send uses, deliberately narrower
   * than `reminderMessage`: only tokens the add-on can always fill from the open
   * Calendar event, so a first-run message never renders with a hole in it. The
   * account's real default keeps `{eventlocation}`; a test send does not, because
   * most sample appointments have no location and a blank there reads as broken
   * to someone who has never seen a token before.
   */
  testReminderMessage: string;
  /**
   * What stands in for `{title}` when the Calendar event has none. Written to
   * read naturally in the `testReminderMessage` title slot, so an untitled
   * appointment renders as a sentence rather than as the gap the token left.
   */
  untitledEventLabel: string;
  legacyReminderMessage: string;
  confirmationMessage: string;
  followUpMessage: string;
  confirmationLinkSuffix: string;
  templateName: string;
  senderName: string;
  location: string;
  calendarStatusLabels: CalendarStatusLabels;
  tokenAliases: Partial<Record<CanonicalToken, string>>;
}
